module.exports = __webpack_public_path__ + "img/leadgrease.abf38c4f.png";